module.exports = __webpack_public_path__ + "static/sysops-associate-59d2c7b1a8f42ceeeffb419c1d6e758d.png";